import { ElementType } from 'react';
import { TextElement, TextProps, Variants } from '@/shared/ui/core';
import cn from 'classnames';
import styles from './text.module.scss';


export const Text = <T extends TextElement = 'div'> ({
    as,
    variant,
    tone = 'primary',
    align = 'left',
    weight = 'regular',
    size = 'md',
    truncate = false,
    className,
    lineHeight = 'normal',
    children,
    ...props
}: TextProps<T>) => {
    const Component       = (as ?? 'div') as ElementType;
    const resolvedVariant = variant ?? Variants[as ?? 'div'] ?? 'normal';
    const resolvedSize    = resolvedVariant === 'normal' ? size : undefined;

    return (
        <Component
            className={ cn(
                styles.root,
                styles[resolvedVariant],
                styles[`tone-${ tone }`],
                styles[`align-${ align }`],
                styles[`weight-${ weight }`],
                {
                    [styles.truncate]                 : truncate,
                    [styles[`size-${ resolvedSize }`]]: resolvedSize,
                },
                className,
            ) }
            style={{
                '--text-lh': lineHeight,
            }}
            { ...props }
        >
            { children }
        </Component>
    );
};
